/**
 * Dashboard Performance Trends level filter preference in localStorage.
 *
 * @module dashboardTrendsLevelStorage
 */

import type { ExamLevel } from '@/types/simulation-results';

const EXAM_LEVELS: readonly ExamLevel[] = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];

export function getDashboardTrendsLevelStorageKey(
  userId: string | undefined | null,
): string {
  return `deutschgenie_dashboard_trends_level_${userId ?? 'guest'}`;
}

export function readDashboardTrendsLevel(
  userId: string | undefined | null,
): ExamLevel | null {
  try {
    const stored = localStorage.getItem(getDashboardTrendsLevelStorageKey(userId));
    if (stored && EXAM_LEVELS.includes(stored as ExamLevel)) {
      return stored as ExamLevel;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function writeDashboardTrendsLevel(
  userId: string | undefined | null,
  level: ExamLevel,
): void {
  try {
    localStorage.setItem(getDashboardTrendsLevelStorageKey(userId), level);
  } catch {
    /* ignore */
  }
}
